import { FC } from 'react';
import { useGetPrivacyAndTerms } from 'view/pages/auth/hooks/useGetPrivacyAndTerms';
import * as S from './styled';

const Agreement: FC = () => {
  const { getPrivacyAndTerms } = useGetPrivacyAndTerms();
  return (
    <S.FormWrapperMainAgreement component="p">
      By continuing, you agree to our{' '}
      <S.FormWrapperMainLink
        onClick={() => {
          return getPrivacyAndTerms('termsAndConditions');
        }}
      >
        Terms of Use
      </S.FormWrapperMainLink>{' '}
      and{' '}
      <S.FormWrapperMainLink
        onClick={() => {
          return getPrivacyAndTerms('privacyPolicy');
        }}
      >
        Privacy Policy
      </S.FormWrapperMainLink>
      .
    </S.FormWrapperMainAgreement>
  );
};

export default Agreement;
